<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
  import './assets/css/reset.css'
  export default {
    name: 'App'
  }
</script>

<style>
  html, body, #app{
    height: 100%;
  }
</style>
